// TODO: odstranit DMS_MODULE je nutno podivat se kde vsude se pouziva
export const DMS_MODULE = 'Servis';
export const NAME = 'Servis';

export const OZAKAZKA = 'Ozakazka';
export const OZAKAZKA_ND = 'Ozakazkand';
export const ZAKAZKA_ND = 'ZakazkaNd';
export const SERVICE_PKG_PARTS = 'ServicePackageParts';
export const SERVICE_PKG_LABOR = 'ServicePackageLabor';
export const SERVICE_PACKAGE = 'ServicePackage';
export const ZAKAZKA_ND_PENDING = 'ZakazkaNdPending';
export const PART_RETURN_REQUEST = 'PartReturnRequest';
export const PLANNED_ORDER_SERVICE_JOB = 'PlannedOrderServiceJob';
export const DefualtQuantity = 0;